import { setReducer } from "../../reducer/creators"
import { SET_IS_FOCUSED } from "../actions"

export const isFocused = setReducer<boolean>([SET_IS_FOCUSED], true)
